<template>
    <div>
        
        <div class="container">
            <Cabecera></Cabecera>
            <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/menuinicial">Inicio Usuario </router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/VerificarGafeteVehiculo">Verificación de Gafete</router-link></b-breadcrumb-item>
    
  </b-breadcrumb>
  <Menu/>
<div class="row">
    <div class="col s12 m12 l12">
      <div class="card">
        <div class="card-content  black-text">
          <span class="card-title">Verificación de Gafete </span>
          <form id="editarUsuario" autocomplete="off" @submit.prevent="editar" enctype="multipart/form-data">
          <input type="text" placeholder="Unidad" :value="unidad" required disabled>
          <input type="date" name="fecharegistro" id="fecharegistro" placeholder="Fecha" v-on:click=getIdusuario() required>
          <input type="text" name="gafete" id="gafete" placeholder="Teléfono" :value="formEditar.gafete"  disabled>
             <input type="submit" name="Estatus" id="Estatus" placeholder="Estatus" v-if="formEditar.estatus === 'ACEPTADO'" :class="boton2" :value="formEditar.estatus">
            <input type="submit" name="Estatus" id="Estatus" placeholder="Estatus" v-else-if="formEditar.estatus === 'RECHAZADO'" :class="boton3" :value="formEditar.estatus" >
            <input type="submit" name="Estatus" id="Estatus" placeholder="Estatus" v-else :class="boton3" value="INEXISTENTE" >
            <input type="text" name="nombre" id="nombre" placeholder="Nombre" :value="formEditar.nombre" disabled>
             <input type="text" name="apellidos" id="apellidos" placeholder="Apellidos" :value="formEditar.apellidos" disabled>
              <input type="text" name="tipo" id="tipo" placeholder="Nombre" :value="formEditar.tipo" disabled>
              <input type="text" name="telefono" id="telefono" placeholder="Teléfono" :value="formEditar.telefono" disabled>
              <input type="hidden" name="usuarioForma" id="usuarioForma" :value=usuariolocal>

            <input type="submit" value="Editar" :class="boton">
            </form>
        </div>
        <div class="card-action">
          
         
        </div>
      </div>
    </div>
  </div>
  
</div> 
    </div>
</template>

<script>

import swal from 'sweetalert'
import axios from 'axios'
import Cabecera from './Cabecera'
import Menu from './Menu'
import sesion from '../mixins/sesion'
import eliminar from '../mixins/eliminar'
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
export default {
    name:'VerificarGafeteVehiculo',
    data(){
        return{
            formEditar:{},
            pass:'',
        passC:'',
        respuesta:'',
        correo:'',
        boton:'btn blue enabled',
        boton2:'btn green btn-lg btn-block',
        boton3:'btn red btn-lg btn-block',
        usuariolocal:'',
        fotolocal:'',
        codigoUnidad:'',
        booleanCodigo:false,
        perfilCodigo:'',
        unidadCodigo:'',
        selected:null,
        unidad:'',
       
        }
        
    },
    components:{
    Cabecera,
    Menu
  },
  created(){
      this.usuario()
     
      
        this.getId()
       
    },
    computed:{
      ...mapState(['usuarioActual','idActual','fotoActual'])
  },
  
    methods:{
       
        usuario(){
        
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     var yourString = this.$localStorage.get('token');
     var result = yourString.slice(1,-1);
     //this.usuariolocal= result
     //const tok=this.usuariolocal
     //this.usuariolocal=result;
      const tok=result
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getUserData.php?token='+tok)
      .then(response=>{
        
        this.$store.commit('GET_USUARIO',response.data.email)
        this.$store.commit('GET_ID',response.data.id)
        this.$store.commit('GET_FOTO',response.data.foto)

        
        this.usuariolocal=response.data.email
        this.fotolocal=response.data.email


      })
      
        },
        getIdusuario(){
         
            
            const id =document.getElementById("usuarioForma").value
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPerfilUsuario.php?id='+id)
            .then(response=>{
                   
                    this.unidad = response.data.unidad
                    
                    this.usuariolocal=response.data.email
                    
                })
                   
        },
        getId(){
           

            const id = this.$route.params.id
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getGafeteVehiculo.php?id='+id)
            
                .then(response=>{
                   
                    this.formEditar = response.data
                    
                  
                })
 }, 
        editar(){
             const form=document.getElementById('editarUsuario')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/editarPerfilUsuario.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                       // this.$router.push('/inicio')
                        swal('El registro fue editado')
                    } else {
                        swal('El post no pudo ser editado'+res.data)
                    }
                })
        },
        ////<h5>RES: {{respuesta}}</h5>
        validEmail: function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
    },
    mixins:[sesion,eliminar],
    
}
</script>


// WEBPACK FOOTER //
// src/components/VerificarGafeteVehiculo.vue